import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const CustomCursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    if (!cursorRef.current) return;

    // Use gsap.quickTo for high performance following
    const xTo = gsap.quickTo(cursorRef.current, "x", { duration: 0.15, ease: "power3" });
    const yTo = gsap.quickTo(cursorRef.current, "y", { duration: 0.15, ease: "power3" });

    const moveCursor = (e) => {
      xTo(e.clientX);
      yTo(e.clientY);
    };

    const addHover = () => {
      gsap.to(cursorRef.current, { scale: 3, backgroundColor: 'transparent', border: '1px solid #fff', duration: 0.3 });
    };

    const removeHover = () => {
      gsap.to(cursorRef.current, { scale: 1, backgroundColor: '#fff', border: 'none', duration: 0.3 });
    };

    window.addEventListener('mousemove', moveCursor);

    // Add magnetic/hover effect on all clickable items
    const interactiveElements = document.querySelectorAll('a, button, input, textarea, .magnetic');
    interactiveElements.forEach((el) => {
      el.addEventListener('mouseenter', addHover);
      el.addEventListener('mouseleave', removeHover);
    });

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      interactiveElements.forEach((el) => {
        el.removeEventListener('mouseenter', addHover);
        el.removeEventListener('mouseleave', removeHover);
      });
    };
  }, []);

  return (
    <div
      ref={cursorRef}
      className="fixed top-0 left-0 w-3 h-3 bg-white rounded-full pointer-events-none z-[9999] mix-blend-difference transform -translate-x-1/2 -translate-y-1/2"
    />
  );
};

export default CustomCursor;
